var map = {
	"./_circle_pink.png": 2361,
	"./btn_close.png": 2954,
	"./circle_blue.png": 1984,
	"./circle_green.png": 6435,
	"./circle_green_sprinter.png": 1761,
	"./circle_orange.png": 982,
	"./circle_orange_sprinter.png": 7234,
	"./circle_pink.png": 1872,
	"./circle_red.png": 9897,
	"./circle_red_sprinter.png": 9969,
	"./collection_place.png": 1875,
	"./collection_place_parked.png": 3291,
	"./comingsoon.png": 5019,
	"./home.png": 78,
	"./logo_hueska.png": 6766,
	"./logo_muka.png": 765,
	"./old_icons/circle_green.png": 2508,
	"./old_icons/circle_orange.png": 1311,
	"./old_icons/circle_pink.png": 1401,
	"./old_icons/circle_red.png": 7816,
	"./rectangle_grey.png": 1512,
	"./triangle_blue.png": 9256,
	"./triangle_green.png": 5147,
	"./triangle_orange.png": 590,
	"./triangle_pink.png": 3272,
	"./triangle_red.png": 443
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4504;